<template>
  <section class="app-container">
    <van-dropdown-menu active-color="#1989fa">
      <van-dropdown-item v-model="params.pickerTime" @change="handleTimeChange" :options="params.pickerTimeOptions" />
    </van-dropdown-menu>
    <component :is="currentList" :orders="orders" :params="data"></component>
  </section>
</template>
<script>
import { Dialog, DropdownMenu, DropdownItem } from 'vant'
import Available from './components/Available'
import Unavailable from './components/Unavailable'
import { deepClone, parseTime } from '@/utils'
import { mapGetters } from 'vuex'
import { selectWxPaidrecordList } from '@/api/park'
import config from '@/config/index'

export default {
  name: 'Invoice-Temporary',
  computed: {
    ...mapGetters(['wx_userInfo', 'zfb_userInfo', 'wx_token', 'token', 'chosenTime'])
  },
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Dialog.Component.name]: Dialog.Component,
    Available,
    Unavailable
  },
  data () {
    return {
      currentList: 'Unavailable',
      listQuery: {
        //过滤参数
        page: 1,
        limit: 10,
      },
      orders: [],
      config,
      data: {},
      params: {
        pickerTime: 1,
        parkId: 0,
        outTradeNo: null,
        pickerTimeOptions: [
          { text: '最近半年', value: 180 }
        ],
        startDate: [
          parseTime(
            new Date(
              new Date(new Date().toLocaleDateString('zh').replace(/-/g, '/')).getTime() - 30 * 24 * 60 * 60 * 1000
            )
          ),
          parseTime(new Date(
            new Date(new Date().toLocaleDateString('zh').replace(/-/g, '/')).getTime() +
            24 * 60 * 60 * 1000 - 1
          ))
        ],
      },
    }
  },
  watch: {
    chosenTime: {
      handler (newVal, oldVal) {
        this.params.pickerTimeOptions = newVal.pickerTimeOptions
        this.params.pickerTime = newVal.pickerTimeOptions[0].value
      },
      deep: true
    },

  },
  mounted () {
    if (this.chosenTime) {
      console.log(this.chosenTime)
      this.params.pickerTimeOptions = this.chosenTime.pickerTimeOptions
      this.params.pickerTime = this.chosenTime.pickerTimeOptions[0].value
    } else {
      this.params.pickerTime = 30
    }
    this.handleTimeChange(this.params.pickerTime)
  },
  methods: {
    // 时间选项改变
    handleTimeChange (val) {
      this.params.startDate[0] = parseTime(new Date(new Date(new Date().toLocaleDateString('zh').replace(/-/g, '/')).getTime() - val * 24 * 60 * 60 * 1000))
      this.componentsValve()
    },
    // 查询数据
    componentsValve () {
      let _this = this
      _this.getInfo_Loading = _this.$toast.loading('加载中...')
      let params = {
        billingStatus: 0,
        isParkingOrRoadside: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,//订单类型 1 停车场  2 路边
        orderType: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,//订单类型 1 停车场  2 路边 3预约 4 关系 5 包月
        openid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo.userId,
        startTime: _this.params.startDate[0],
        endTime: _this.params.startDate[1],
        startPage: _this.listQuery.page,
        pageSize: _this.listQuery.limit,
      }
      this.data = params
      selectWxPaidrecordList(params).then(res => {
        let data = []
        for (let item of res.body.list) {
          if (item.billingStatus == 0) {
            data.push(item)
          }
        }
        // data.forEach(element => {
        //   if (typeof element.paidMoney === 'number') {
        //     element.priceArr = element.paidMoney.toFixed(2).split('.')
        //   } else {
        //     element.paidMoney = element.paidMoney.slice(0, element.paidMoney.length - 2) + '.' + element.paidMoney.slice(element.paidMoney.length - 2)
        //     element.priceArr = (element.paidMoney - 0).toFixed(2).split('.')
        //   }
        // });

        _this.getInfo_Loading.clear()
        if (data.length > 0) {
          _this.orders = deepClone(data)
          _this.data = params
          _this.currentList = 'Available'
        } else {
          _this.currentList = 'Unavailable'
        }
      }).catch(err => {
        _this.getInfo_Loading.clear()
        _this.$notify({
          type: 'danger',
          message: err
        })
      })
    },
    onClickRight () {
      Dialog.alert({
        title: '开票说明',
        confirmButtonColor: '#1989fa',
        message: '仅支持最近3个月内的缴费记录开票'
      })
    }
  }
}
</script>